// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminLeadSearchResponse

import { hydrateAdminLeadListItem, type AdminLeadListItem, type AdminLeadListItemApiResponse } from './adminLeadListItem.gen';

export type AdminLeadSearchApiResponse = {
	items: AdminLeadListItemApiResponse[];
};

export type AdminLeadSearch = {
	items: AdminLeadListItem[];
};

export function hydrateAdminLeadSearch(data: AdminLeadSearchApiResponse): AdminLeadSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminLeadListItem),
	};
}